import { DestroyRef, ElementRef, Signal, effect, inject, signal } from '@angular/core';

import { observeElementHeight } from '@shared/utils/dom/observe-element-height.util';
import { RouteScrollMode } from '../../../../layout/scroll-ownership/route-scroll-mode.models';
import { RouteScrollModeRuntime } from '../../../../layout/scroll-ownership/route-scroll-mode.runtime';

export interface MeasuredElementHeightTracker {
  readonly height: Signal<number>;
  observe(elementRef: ElementRef<HTMLElement> | undefined): void;
}

export function registerRouteShellScrollMode(scrollMode: Signal<RouteScrollMode>): void {
  const routeScrollModeRuntime = inject(RouteScrollModeRuntime);

  effect((onCleanup) => {
    const cleanup = routeScrollModeRuntime.register(scrollMode());
    onCleanup(cleanup);
  });
}

export function createMeasuredElementHeightTracker(): MeasuredElementHeightTracker {
  const destroyRef = inject(DestroyRef);
  const measuredHeight = signal(0);
  let cleanup: (() => void) | null = null;

  destroyRef.onDestroy(() => {
    cleanup?.();
    cleanup = null;
  });

  return {
    height: measuredHeight.asReadonly(),
    observe(elementRef) {
      cleanup?.();
      cleanup = observeElementHeight(elementRef, (height) => {
        measuredHeight.set(height);
      });
    },
  };
}
